<template>
  <v-main>
    <v-container style="height: 100vh;">
      <img :class="{'topleft':true,'smalll':$vuetify.breakpoint.xsOnly}" :src="require('@/assets/HTC_Asset_28.png')"  />
      <img :class="{'topright':true,'smallr':$vuetify.breakpoint.xsOnly}" :src="require('@/assets/HTC_Asset_28.png')"  />
      <img class="bottomleft" :src="require('@/assets/HTC_Asset_28.png')"  />
      <img class="bottomright" :src="require('@/assets/HTC_Asset_28.png')"  />
      <v-row >
        <v-col align="center">
          <div style="width:100%;height:40px;"></div>
          <v-card  max-width="800" outlined >
            <v-img style="background-color: #000;" :src="require('@/assets/coatesnhoff2020.png')" max-height="400" position="top" contain aspect-ratio="1">

            </v-img>
            <v-card-title>
              Dec 5th 2020
            </v-card-title>
            <v-card-text class="text-justify">
              <p>
                This year, the Coates N Hoff will happen at Scottsdale Ranch Park; We will no longer be held hostage by the year 2020.
                We are currently checking with the City of Scottsdale to procure permission to burn a 50' effigy of 2020. May it go down in flames,
                back to the hell from whence it game, to nestle next to the hand sets you all consider legal..
              </p>
              <p>
                Please read the <v-btn text to="/faqs">FAQs</v-btn> and be ready to ball out.. We anticipate 24 teams, so please register soon.. like adults.. not on the last day,
                like 6 of you did last year... (you know who you are!)
              </p>
            </v-card-text>
            <v-card-actions>
              <a href="https://grayhawkbeach.volleyballlife.com/tournament/1601" target="_blank">
                <v-btn text>Register</v-btn>
              </a>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>


import HomePage from "../components/home/HomePage";
import EventById from "../components/event/EventById";
export default {
  components: {
    EventById,
    HomePage
  },
  computed:{
    loggedIn(){
      return this.$store.state.loggedin
    }
  }
};
</script>

<style>
  a{
    text-decoration: none;
  }
  .topleft{
    position: fixed;
    top:52px;
    left:5px;
    width:35%;
    transform: scale(-1,-1);
    transition: all 1s ease-in-out;
  }
  .topright{
    position: fixed;
    top:52px;
    right:5px;
    width:35%;
    transform: scale(1,-1);
    transition: all 1s ease-in-out;
  }

  .smalll{
    transform: scale(-1,-1.5) translate(5px,-10px);
  }
  .smallr{
    transform: scale(1,-1.5) translate(5px,-10px);
  }

  .bottomleft{
    position: fixed;
    bottom:5px;
    left:5px;
    width:30%;
    height:15%;
    transform: scale(-1,1);
    transition: all 1s ease-in-out;
  }
  .bottomright{
    position: fixed;
    bottom:5px;
    right:5px;
    width:30%;
    height:15%;
    transform: scale(1);
    transition: all 1s ease-in-out;
  }
</style>
